import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class ChatDriverStore {
    driverlist = [];
    total = 0;
    loading = false;
    messages = [];
    hasUnreadMessages = false;
    driverIdsWithUnread = [];
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            driverlist: observable,
            total: observable,
            loading: observable,
            messages: observable,
            hasUnreadMessages: observable,
            driverIdsWithUnread: observable,
            getDriverDetails: action,
            getAllMessages: action

        });
        this.rootStore = rootStore;
    }

    async getDriverDetails(data) {
        this.loading = true;
        const base64Input = await base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()

            .post("index.php?c=driver&a=getLatestDriverDetails", "postData=" + base64Input);
        // .post("index.php?c=driver&a=getDriverDetails", "postData=" + base64Input);
        console.log(response.data)
        this.driverlist = response?.data?.data;
        // this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
        return response?.data?.data;
    }

    async getAllMessages(data) {
        this.loading = true;
        const base64Input = await base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()
            .post("index.php?c=driver&a=getAllMessages", "postData=" + base64Input);
        console.log(response)
        const messages = response?.data?.data;
        this.messages = messages;

        // this.hasUnreadMessages = messages.some(
        //     (msg) => msg.isRead === "0"
        // );

        // this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
        return response?.data?.data;
    }
    async sendMessage(data) {
        this.loading = true;
        const base64Input = base64_encode(JSON.stringify(data));
        const res = await postApi
            .getClient()
            .post("index.php?c=driver&a=sendMessage", "postData=" + base64Input);
        this.loading = false;
    }
    async getMessages(data) {
        // this.loading = true;
        const base64Input = await base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()
            .post("index.php?c=driver&a=getMessages", "postData=" + base64Input);
        console.log(response)
        const messages = response?.data?.data;
        this.messages = messages;

        this.hasUnreadMessages = messages.length > 0 ? true : false;
        const unreadDriverIds = [
            ...new Set(
                messages
                    .filter(msg => Number(msg.isRead) === 0)
                    .map(msg => msg.driverId)
            )
        ];
        console.log(unreadDriverIds)

        this.driverIdsWithUnread = unreadDriverIds;
        // this.total = parseInt(response?.data?.data?.TotalCount);
        // this.loading = false;
        return response?.data?.data;
    }


}

export default ChatDriverStore;
